import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/forum/[id]/ThreadPage.tsx");
